import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** 表示するコンポーネントの種類 */
  type: 'message';
  /** サブタイプ */
  subType?:
    | 'default'
    | 'red'
    | 'date'
    | 'status'
    | 'status red'
    | 'name'
    | 'canceled'
    | 'left';
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * メッセージコンポーネント
 */
export const Message: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type = 'message',
  subType = 'default',
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _tmpType = className || type;
  const _clsName = subType === 'default' ? _tmpType : `${_tmpType} ${subType}`;
  return (
    <Element {...props} className={_clsName}>
      {props.children}
    </Element>
  );
};
Message.displayName = 'Message';
